import React from 'react';

interface LoadingSpinnerProps {
    message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = 'טוען...' }) => {
    return (
        <div className="flex flex-col items-center justify-center py-12 space-y-4">
            <div className="loading-spinner"></div>
            <p className="text-brand-dark/60 font-medium">{message}</p>
        </div>
    );
};

export default LoadingSpinner;
